import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { USER_ROLES, localStorage } from "./utils";

export default function ProtectedRoute({ requiredRole }) {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role");
  const authorized =
    userRole === requiredRole || // User has same role -> ok
    userRole === USER_ROLES.SUPER_ADMIN || // user is super admin -> ok
    (requiredRole === USER_ROLES.TEACHER && userRole === USER_ROLES.ADMIN); // Admin can also do teacher functionality but not SA func

  useEffect(() => {
    if (authorized) {
      return;
    }

    navigate("/login");
  }, []);

  return authorized ? <Outlet /> : null;
}
